<template>
  <div class="home-container">
    <div class="top_img">
      <img src="../../../assets/images/desktop/check-mark.png" alt="图片加载中...">
      <div>转账成功</div>
    </div>
    <van-cell-group inset>
      <van-cell title="转出账户">
        <template>
          <div>{{ transferAccounts.outAccountName }}</div>
          <div class="id">ID：{{ transferAccounts.outAccountId }}</div>
        </template>
      </van-cell>
      <van-cell title="转入账户">
        <template>
          <div>{{ transferAccounts.toAccountName }}</div>
          <div class="id">ID：{{ transferAccounts.toAccountId }}</div>
        </template>
      </van-cell>
      <van-cell title="资金类型" value="预付-通用金额" />
      <van-cell title="转账金额" :value="transferAccounts.money + '元'" />
      <van-cell title="转账时间" :value="transferAccounts.time" />
    </van-cell-group>
  </div>
</template>

<script>

export default {
  props: {},
  data() {
    return {
      transferAccounts: {
        outAccountId: null,
        outAccountName: null,
        toAccountId: null,
        toAccountName: null,
        money: null,
        time: null
      }
    }
  },
  watch: {
    '$route' (to, from) {
      // 在mounted函数执行的方法，放到该处
      if (this.$route.query.outAccountId) {
        this.transferAccounts = this.$route.query
      }
    }
  },
  // created() {

  // },
  mounted() {
    if (this.$route.query.outAccountId) {
      this.transferAccounts = this.$route.query
    }
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '转账结果'
    }
  }
}
</script>

<style scoped lang="less">
.home-container{
  height: 85vh;
  background-color: #f7f8fc;
  padding: 40px 0;
  display: flex;
  // align-items: center;
  justify-content: space-between;
  flex-direction: column;
  .top_img{
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    img{
      width: 180px;
      margin-top: 40px;
    }
    div{
      font-size: 42px;
      font-weight: bold;
      margin-top: 60px;
      letter-spacing: 2px;
    }
  }
  /deep/ .van-cell{
    padding: 32px;
  }
  /deep/ .van-cell-group--inset{
    margin: 0 20px;
  }
  /deep/ .van-cell__title{
    color: #9b9b9b;
    font-size: 30px;
    -webkit-box-flex: 0.25;
    -webkit-flex: 0.25;
    flex: 0.25;
  }
  /deep/ .van-cell__value{
    color: #333333;
    font-size: 28px;
    font-weight: bold;
  }
  .id{
    color: #9b9b9b;
    font-size: 26px;
  }
}
</style>
